import FilterReportDateItens from "../../../../components/filter/reportDateItens/filter";
import reqVenda from "../../../../services/reqMultiTenant/reqVenda";

import MainReportMatrix from "../../matrix";

const SoldTypeClient = (props) => {
	const options = {
		title: "Vendas por tipo de cliente",
		subTitle: "* Este relatório fornece o valor líquido de vendas por cliente, subtraindo entregas e descontos",
		ident: "soldTypeClient", //usado para definir os event listners
		identFilter: "filterSoldClientType", //usado para definir os event listners
		identReport: "reportSoldTypeClient", //usado para definir os event listners
		tableColumns: [
			{ key: "nome", label: "Nome", align: "left" },
			{ key: "qtdecliente", label: "Qtde.", align: "left" },
			{ key: "valor", label: "Valor", align: "center" },
			{ key: "perc", label: "Percentual", align: "center" },
		],
		reportColumns: [
			{ key: "nome", label: "Nome", align: "left" },
			{ key: "qtdecliente", label: "Qtde.", align: "left" },
			{ key: "valor", label: "Valor", align: "right", format: "currency" },
			{ key: "perc", label: "Percentual", align: "center" },
		],

		showTime: true, //mostra a hora no filtro de data
		hasActive: false, //ativa o filtro de ativo
		hasSaleType: true, //ativa o filtro de tipo de venda
		parametersDate: [{ id: 1, label: "Data da venda", value: "dtVenda" }],
		hasParam: false,
		parametersFilter: [
			{ id: 1, label: "Tirar", value: "tirar" },
			// { id: 2, label: "Grupo", value: "grupo" },
			// { id: 3, label: "SubGrupo", value: "subgrupo" },
			// { id: 4, label: "Fornecedor", value: "fornecedor" },
			// { id: 5, label: "Referência", value: "referencia" },
		],
	};

	const fetch = async (filterData, newPage, perPage = 15) => {
		const newFilterData = { ...filterData, page: newPage, perPage };

		const response = await reqVenda.listByClient(newFilterData);

		return response;
	};

	//chama o relatório passando os options e a função fetch e o filtro de pesquisa
	return (
		<div className="flex flex-col mt-14 min-h-[calc(100vh-6.5rem)]">
			<MainReportMatrix options={options} fetch={fetch} FormFilter={FilterReportDateItens}></MainReportMatrix>
		</div>
	);
};

export default SoldTypeClient;
